import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import useProductContent from '~/composables/useProductContent/useProductContent';
export default defineComponent({
  name: 'TheTabSection',
  components: {
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    }
  },
  props: {
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    lastTabContentsLastElement: Object
  },
  setup: function setup(props) {
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    provide('isInTabSection', true);
    provide('isFullWidth', false);
    provide('isInPageAdvice', false);
    var checkIfBlockIngredients = function checkIfBlockIngredients(content) {
      var _content$sys, _content$sys$contentT, _content$sys$contentT2;
      return ((_content$sys = content.sys) === null || _content$sys === void 0 ? void 0 : (_content$sys$contentT = _content$sys.contentType) === null || _content$sys$contentT === void 0 ? void 0 : (_content$sys$contentT2 = _content$sys$contentT.sys) === null || _content$sys$contentT2 === void 0 ? void 0 : _content$sys$contentT2.id) === 'blockIngredients';
    };
    var checkIfContentIsEmpty = function checkIfContentIsEmpty(contentFieldsKeys) {
      return contentFieldsKeys.length === 1 && contentFieldsKeys.includes('displayOptions') || contentFieldsKeys.length === 0;
    };
    var mappedTabComponents = computed(function () {
      return mapComponentName(props.tabs).map(function (tab) {
        if (tab.fields.contents) {
          var _tab$fields$contents$, _tab$fields$contents$2, _tab$fields$contents$3, _tab$fields$contents$4;
          tab.fields.contents.forEach(function (content, index) {
            if (!content.fields) {
              return;
            }
            var contentFieldsKeys = Object.keys(content.fields);
            if (checkIfContentIsEmpty(contentFieldsKeys) && !checkIfBlockIngredients(content) // blockIngredients can be completely empty in Contentful but should still be dispalyed
            ) {
              tab.fields.contents.splice(index, 1);
            }
          });
          if (((_tab$fields$contents$ = tab.fields.contents[0]) === null || _tab$fields$contents$ === void 0 ? void 0 : (_tab$fields$contents$2 = _tab$fields$contents$.sys) === null || _tab$fields$contents$2 === void 0 ? void 0 : (_tab$fields$contents$3 = _tab$fields$contents$2.contentType) === null || _tab$fields$contents$3 === void 0 ? void 0 : (_tab$fields$contents$4 = _tab$fields$contents$3.sys) === null || _tab$fields$contents$4 === void 0 ? void 0 : _tab$fields$contents$4.id) === 'blockTabsContainer') {
            tab.fields = _objectSpread(_objectSpread({}, tab.fields), {}, {
              isInTabContainer: true
            });
          }
        }
        tab.fields = _objectSpread(_objectSpread({}, tab.fields), {}, {
          lastTabContentsLastElement: props.lastTabContentsLastElement
        });
        return tab;
      });
    });
    return {
      mappedTabComponents: mappedTabComponents
    };
  }
});